import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
if (!isMobile)
    import('./learning.css').then(() => {});
else
    import('./learning_mob.css').then(() => {});

function Learning({}) {
    const [data,setData] = useState([
        {   
            question:"Que va-t-on me demander ?", 
            responses:['dohsoehfeoeiohfe','ojhdfsiofhosdiojfsio j'],display:'none',btnText:'+'
        },
        {   
            question:"Que va-t-on me demander ?", 
            responses:['dohsoehfeoeiohfe','ojhdfsiofhosdiojfsio j'],display:'none',btnText:'+'
        }
    ]);
    const {target,id} = useParams()
    
    const ChangeDisplay=(index,btnTarget)=>{
        if(data[index].display==='none')
        {data[index].display='block';data[index].btnText='-';}
        else
        {data[index].display='none';data[index].btnText='+';}
        setData([...data]);
    }

    const ChangeResponse = (index_q,index_r,value)=>
    {
        data[index_q].responses[index_r] = value;
        setData([...data]);
    }

    const AddResponse = (index)=>
    {
        if(data[index].responses[data[index].responses.length-1] !== '')
            {data[index].responses.push('');setData([...data]);}
    }

    const AddQuestion = ()=>
    {
        if(data[data.length-1].question!=='')
        {data.push({question:'',responses:[],display:'none',btnText:'+'});setData([...data]);}
    }

    const DeleteResponse=(index_q,index_r)=>
    {
        data[index_q].responses.splice(index_r,1);
        setData([...data]);
    }

    const DeleteQuestion = (index)=>
    {

        data.splice(index,1);
        setData([...data]);
    }

  return (
    <div id='ai-learning'>
        <input onClick={e=>{AddQuestion()}} className='btn-add' style={{backgroundColor:'lightblue',color:'black'}} type='button' value={'Nouvelle Question'} />
        <input className='btn-add' style={{backgroundColor:'lightgreen'}} type='button' value={'Enregister'} />
            <div className='question-response'>
                {   
                    data.map((qr,index_qr)=>{
                        return(
                        <div style={{display:'block'}}>
                            <div className='question'>
                                <input onClick={e=>{ChangeDisplay(index_qr,e.target)}} type='button' value={qr.btnText} className='btn-qr' />
                                <input className='question-input' type='text' value={qr.question} placeholder='Que va-t-on me demander ?' />
                                <BrowserView style={{width:'18%'}}>
                                    <input onClick={e=>{DeleteQuestion(index_qr)}} className='btn-delete' type='button' value={'supprimer'} />
                                </BrowserView>
                                <MobileView style={{display:'inline-block',verticalAlign:'middle',marginLeft:'5px'}}>
                                    <img onClick={e=>{DeleteQuestion(index_qr)}} src='/images/icons/remove/remove.png' style={{height:'25px',display:'inline-block'}} />
                                </MobileView>
                            </div>
                            <div className='responses' style={{display:qr.display}}>
                                {
                                    qr.responses.map((resp,index_res)=>{
                                    return (<div className='response'>
                                        <textarea onChange={(e)=>{ChangeResponse(index_qr,index_res,e.target.value)}} defaultValue={resp} className='response-input' />
                                        <BrowserView style={{width:'18%'}}>
                                            <input onClick={e=>{DeleteResponse(index_qr,index_res)}} type='button' value={'supprimer'} className='btn-delete' style={{borderRadius:'5px'}} />
                                        </BrowserView>
                                        <MobileView style={{display:'inline-block',verticalAlign:'middle',marginLeft:'5px'}}>
                                            <img onClick={e=>{DeleteQuestion(index_qr)}} src='/images/icons/remove/remove.png' style={{height:'25px',display:'inline-block'}} />
                                        </MobileView>
                                    </div>)
                                    })
                                }
                                <input onClick={e=>{AddResponse(index_qr)}} className='btn-add' type='button' value={'Ajouter une reponse'} />
                            </div>
                            </div>
                        );})
                }
        </div>
    </div>
  )
}
export default Learning
